import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';

export const selectDV360TicketsInsertionOrders = (state: RootState) => state.dv360TicketsInsertionOrders;

export const selectDV360TicketsActiveInsertionOrder = createSelector(
  [selectDV360TicketsInsertionOrders],
  ({ activeInsertionOrder, activeInsertionOrderRequestId, activeInsertionOrderError }) => ({
    activeInsertionOrder,
    activeInsertionOrderError,
    loading: !!activeInsertionOrderRequestId,
  }),
);

export const selectDCV360TicketsProducts = createSelector(
  [selectDV360TicketsInsertionOrders],
  ({ products, productRequestId }) => ({
    products,
    loading: !!productRequestId,
  }),
);

export const selectDV360TicketsAudiences = createSelector(
  [selectDV360TicketsInsertionOrders],
  ({ audiences, audienceRequestId }) => ({
    audiences,
    loading: !!audienceRequestId,
  }),
);

export const selectDV360TicketsLineItem = createSelector(
  [selectDV360TicketsActiveInsertionOrder, (_, index: number) => ({ index })],
  ({ activeInsertionOrder }, { index }) => activeInsertionOrder?.lineItems?.[index],
);

export const selectDV360TicketsActiveInsertionOrderAdvertiser = createSelector(
  [selectDV360TicketsInsertionOrders],
  ({ activeInsertionOrder }) => activeInsertionOrder?.advertiser,
);
